import FootballEventsSummary from "./FootballEventsSummary";
export default FootballEventsSummary;
